import styled from 'styled-components';

export const IconWrapper = styled.div`
	display: grid;
	grid-template-columns: repeat(4, auto);
	grid-column-gap: 38px;

	@media (max-width: 1024px) {
		grid-column-gap: 24px;
	}

	@media (max-width: 420px) {
		grid-column-gap: 16px;
	}
`;

export const Icon = styled.figure`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 10px;
	padding: 0;
	margin: 0;

	div {
		width: 66px;
		height: 66px;
		display: flex;
		align-items: center;
		justify-content: center;
		margin: 0;
		padding: 0;
		border-radius: 8px;
		border: 1.5px solid rgba(255, 255, 255, 0.25);
		background: linear-gradient(318deg, #d5d7ff 4.43%, #dbd7ff 51.04%, #73a7f6 95.53%),
			linear-gradient(160deg, #303cf6 -169.31%, #d4e0ff 88.76%);

		svg {
			width: 36px;
			height: 36px;
			fill: ${({ theme }) => theme.primaryColor};
		}
	}

	figcaption {
		margin: 0;
		font-weight: 500;
	}

	@media (max-width: 420px) {
		${({ theme }) => theme.typography.textXS};

		div {
			width: 48px;
			height: 48px;

			svg {
				width: 24px;
				height: 24px;
			}
		}
	}
`;
